import React from 'react';
import './SocialSidebar.css';
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTelegramPlane,
  FaWhatsapp,
} from 'react-icons/fa';

import threadsIcon from '../assets/threads-icon.png'; // Custom Threads icon

const SocialSidebar = () => {
  return (
    <div className="social-sidebar">
      

      <a
        href="https://facebook.com/kashmirjobsfb"
        className="facebook"
        target="_blank"
        rel="noopener noreferrer"
        title="Facebook"
      >
        <FaFacebookF />
      </a>

      <a
        href="https://instagram.com/kashmir_jobs"
        className="instagram"
        target="_blank"
        rel="noopener noreferrer"
        title="Instagram"
      >
        <FaInstagram />
      </a>

      <a
        href="https://www.linkedin.com/in/kashmir-jobs"
        className="linkedin"
        target="_blank"
        rel="noopener noreferrer"
        title="LinkedIn"
      >
        <FaLinkedinIn />
      </a>

      <a
        href="https://t.me/kashmir_jobs"
        className="telegram"
        target="_blank"
        rel="noopener noreferrer"
        title="Telegram"
      >
        <FaTelegramPlane />
      </a>

      <a
        href="https://wa.me/918494056223"
        className="whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        title="WhatsApp"
      >
        <FaWhatsapp />
      </a>

      <a
        href="https://www.threads.net/@kashmir_jobs"
        className="threads"
        target="_blank"
        rel="noopener noreferrer"
        title="Threads"
      >
        <img src={threadsIcon} alt="Threads Icon" />
      </a>
    </div>
  );
};

export default SocialSidebar;
